export const ACESSOS = {
    HELPDESK: {
        TELAS: {
            ATENDIMENTO: {
                ID_TELA: 544 as const,
                DS_PATH: "/HelpDesk/Atendimento" as const,
            } as const,
            GESTAO_RESPOSTAS: {
                ID_TELA: 555 as const,
                DS_PATH: "/HelpDesk/GestaoRespostas" as const,
            } as const,
            PESQUISA_SATISFACAO: {
                ID_TELA: 707 as const,
                DS_PATH: "/HelpDesk/PesquisaSatisfacao" as const,
            } as const,
            GESTAO_ATENDIMENTOS: {
                ID_TELA: 543 as const,
                DS_PATH: "/HelpDesk/GestaoAtendimentos" as const,
            } as const,
            WHATSAPP_BI: {
                ID_TELA: 676 as const,
                DS_PATH: "/HelpDesk/BIWhatsApp" as const,
            } as const,
            WHATSAPP_BOT_BI: {
                ID_TELA: 676 as const,
                DS_PATH: "/HelpDesk/BIBotWhatsApp" as const,
            } as const,
            WHATSAPP_BINPS: {
                ID_TELA: 720 as const,
                DS_PATH: "/Helpdesk/BINps" as const,
            } as const,
            WHATSAPP_BICSAT: {
                ID_TELA: 721 as const,
                DS_PATH: "/HelpDesk/BiCsat" as const,
            } as const,
            DASHBOARD: {
                ID_TELA: 541 as const,
                DS_PATH: "/HelpDesk/Dashboard" as const,
            } as const,
            GESTAO_EQUIPES: {
                ID_TELA: 542 as const,
                DS_PATH: "/HelpDesk/Equipes" as const,
            } as const,
            GESTAO_CLIENTES: {
                ID_TELA: 536 as const,
                DS_PATH: "/HelpDesk/GestaoClientes/" as const,
            } as const,
            GESTAO_TEMPLATES: {
                ID_TELA: 536 as const,
                DS_PATH: "/HelpDesk/GestaoTemplates/" as const,
            } as const,
            CONFIGURAR_TEMPLATES: {
                ID_TELA: 536 as const,
                DS_PATH:
                    "/HelpDesk/GestaoTemplates/ConfigurarTemplates/:idDocumentoTemplate" as const,
                DS_LINK: (idDocumentoTemplate: number) =>
                    `/HelpDesk/GestaoTemplates/ConfigurarTemplates/${idDocumentoTemplate}` as const,
            } as const,

            GESTAO_TEMPLATES_TWILIO: {
                ID_TELA: 536 as const,
                DS_PATH: "/HelpDesk/GestaoTemplatesTwilio/" as const,
            } as const,
            CONFIGURAR_TEMPLATES_TWILIO: {
                ID_TELA: 536 as const,
                DS_PATH:
                    "/HelpDesk/GestaoTemplates/ConfigurarTemplatesTwilio/:name/:contentType" as const,
                DS_LINK: (name: string, contentType: string) =>
                    `/HelpDesk/GestaoTemplates/ConfigurarTemplatesTwilio/${name}/${contentType}` as const,
            } as const,
            CLIENTE: {
                ID_TELA: 574 as const,
                DS_PATH: "/HelpDesk/Cliente/:idConta" as const,
                DS_LINK: (IDConta: number) =>
                    `/HelpDesk/Cliente/${IDConta}` as const,
            } as const,
        },
        DS_BASE_URL: "/HelpDesk",
        NAME: "HelpDesk",
        ID_MODULO: 8 as const,
    } as const,

    COBRANCA: {
        TELAS: {
            ATENDIMENTO: {
                ID_TELA: 575 as const,
                DS_PATH: "/Cobranca/Atendimento/:IDCaso" as const,
                DS_LINK: (IDCaso: number) =>
                    `/Cobranca/Atendimento/${IDCaso}` as const,
            } as const,
            GESTAO_CLIENTES: {
                ID_TELA: 536 as const,
                DS_PATH: "/Cobranca/GestaoClientes/" as const,
            } as const,
            CLIENTE: {
                ID_TELA: 574 as const,
                DS_PATH: "/Cobranca/Cliente/:idConta" as const,
                DS_LINK: (IDConta: number) =>
                    `/Cobranca/Cliente/${IDConta}` as const,
            } as const,
            FILA_ATENDIMENTOS: {
                ID_TELA: 551 as const,
                DS_PATH: "/Cobranca/FilaAtendimentos" as const,
            } as const,
            GESTAO_ATENDIMENTOS: {
                TODOS: {
                    ID_TELA: 552 as const,
                    DS_PATH: "/Cobranca/TodosAtendimentos",
                },
                USUARIO: {
                    ID_TELA: 572 as const,
                    DS_PATH: "/Cobranca/MeusAtendimentos",
                },
                // GRUPO: {
                //     ID_TELA: 573 as const,
                //     DS_PATH: "/Cobranca/GrupoAtendimentos",
                // },
                // ACOMPANHAMENTO: {
                //     ID_TELA: 578 as const,
                //     DS_PATH: "/Cobranca/MeusAcompanhamentos",
                // },
                DS_PATH: "/Cobranca/Atendimentos" as const,
            } as const,
            TRIAGEM: {
                ID_TELA: 557 as const,
                DS_PATH: "/Cobranca/Triagem/" as const,
            } as const,
            DASHBOARD: {
                ID_TELA: 554 as const,
                DS_PATH: "/Cobranca/Dashboard" as const,
            } as const,
            GESTAO_ACORDOS: {
                ID_TELA: 563 as const,
                DS_PATH: "/Cobranca/GestaoAcordosCobranca" as const,
            } as const,
            RENEGOCIACAO_GRUPO: {
                ID_TELA: 717 as const,
                DS_PATH: "/Cobranca/RenegociacaoGrupo" as const,
            } as const,
            CAPYS_BI: {
                ID_TELA: 564 as const,
                DS_PATH: "/Cobranca/CapysBI" as const,
            } as const,
            DISTRIBUICAO_CARTEIRA: {
                ID_TELA: 597 as const,
                DS_PATH: "/Cobranca/DistribuicaoCarteira" as const,
            } as const,
            RELATORIO_CONTATO: {
                ID_TELA: 607 as const,
                DS_PATH: "/Cobranca/RelatorioContatoCobranca" as const,
            } as const,
            GESTAO_TITULOS: {
                ID_TELA: 617 as const,
                DS_PATH: "/Cobranca/GestaoTitulosCobranca" as const,
            } as const,
            ALCADA_DESCONTO: {
                ID_TELA: 661 as const,
                DS_PATH: "/Cobranca/AlcadaDesconto" as const,
            } as const,
            SERASA: {
                ID_TELA: 708 as const,
                DS_PATH: "/Cobranca/Serasa" as const,
            } as const,

            GESTAO_ATIVIDADES: {
                ID_TELA: 726 as const,
                DS_PATH: "/Cobranca/GestaoAtividades" as const,
            } as const,
            APROVACAO_RENEGOCIACOES: {
                ID_TELA: 701 as const,
                DS_PATH: "/Cobranca/AprovacaoRenegociacoes" as const,
            } as const,
        },
        MODAIS: {
            MOTIVO_INADIMPLENCIA: {
                ID_TELA: 549 as const,
            } as const,
            RESULTADO_CONTATO: {
                ID_TELA: 548 as const,
            } as const,
            OBRA_COBRANCA: {
                ID_TELA: 556 as const,
            } as const,
            CLASSIFICACAO_COBRANCA: {
                ID_TELA: 562 as const,
            } as const,
        },
        DS_BASE_URL: "/Cobranca",
        NAME: "Cobranca",
        ID_MODULO: 3 as const,
    } as const,

    ATENDIMENTO: {
        TELAS: {
            ATENDIMENTO: {
                ID_TELA: 576 as const,
                DS_PATH: "/Atendimento/Atendimento/:IDCaso" as const,
                DS_LINK: (IDCaso: number) =>
                    `/Atendimento/Atendimento/${IDCaso}` as const,
            } as const,
            GESTAO_CLIENTES: {
                ID_TELA: 536 as const,
                DS_PATH: "/Atendimento/GestaoClientes/" as const,
            } as const,
            CLIENTE: {
                ID_TELA: 574 as const,
                DS_PATH: "/Atendimento/Cliente/:idConta" as const,
                DS_LINK: (IDConta: number) =>
                    `/Atendimento/Cliente/${IDConta}` as const,
            } as const,
            GESTAO_ATENDIMENTOS: {
                TODOS: {
                    ID_TELA: 545 as const,
                    DS_PATH: "/Atendimento/Gestao/Todos" as const,
                },
                GRUPO: {
                    ID_TELA: 567 as const,
                    DS_PATH: "/Atendimento/Gestao/Grupo" as const,
                },
                MEUS_ATENDIMENTOS: {
                    ACOMPANHAMENTO: {
                        ID_TELA: 577 as const,
                    },
                    USUARIO: {
                        ID_TELA: 566 as const,
                    },
                    DS_PATH: "/Atendimento/Gestao/Meus" as const,
                } as const,
            } as const,
            TRIAGEM: {
                ID_TELA: 557 as const,
                DS_PATH: "/Atendimento/Triagem/" as const,
            } as const,
            DASHBOARD: {
                ID_TELA: 546 as const,
                DS_PATH: "/Atendimento/Dashboard" as const,
            } as const,
            CAPYS_BI: {
                ID_TELA: 565 as const,
                DS_PATH: "/Atendimento/CapysBI" as const,
            } as const,
            CAPYS_BIPERFILCLIENTES: {
                ID_TELA: 671 as const,
                DS_PATH: "/Atendimento/CapysBIPerfilClientes" as const,
            } as const,
            CAPYS_BINPS: {
                ID_TELA: 718 as const,
                DS_PATH: "/Atendimento/BINps" as const,
            } as const,
            CAPYS_BICSAT: {
                ID_TELA: 719 as const,
                DS_PATH: "/Atendimento/BICsat" as const,
            } as const,

            GESTAO_ATIVIDADES: {
                ID_TELA: 726 as const,
                DS_PATH: "/Atendimento/GestaoAtividades" as const,
            } as const,

            PESQUISA_SATISFACAO: {
                ID_TELA: 707 as const,
                DS_PATH: "/Atendimento/PesquisaSatisfacao" as const,
            } as const,
        },
        DS_BASE_URL: "/Atendimento",
        NAME: "Atendimento",
        ID_MODULO: 2 as const,
    } as const,

    GERAL: {
        TELAS: {
            CLIENTE: {
                ID_TELA: 574 as const,
                DS_PATH: "/Geral/Cliente/:idConta" as const,
                DS_LINK: (IDConta: number) =>
                    `/Geral/Cliente/${IDConta}` as const,
            } as const,
            GESTAO_GRUPOS: {
                ID_TELA: 529 as const,
                DS_PATH: "/Geral/Grupos/" as const,
            } as const,
            GESTAO_USUARIOS: {
                ID_TELA: 538 as const,
                DS_PATH: "/Geral/Usuarios/" as const,
            } as const,
            GESTAO_CLIENTES: {
                ID_TELA: 536 as const,
                DS_PATH: "/Geral/GestaoClientes/" as const,
            } as const,
            CADASTRAR_CLIENTE: {
                ID_TELA: 696 as const,
                DS_PATH: "/Geral/CadastrarCliente/" as const,
            } as const,
            // ADD ID TELA NO BANCO
            GESTAO_ATENDIMENTOS: {
                ID_TELA: 537 as const,
                DS_PATH: "/Geral/Atendimentos" as const,
            } as const,
            GESTAO_PRODUTOS: {
                ID_TELA: 537 as const,
                DS_PATH: "/Geral/GestaoProdutos" as const,
            } as const,
            FORMULARIOS_PRODUTOS: {
                ID_TELA: 702 as const,
                DS_PATH: "/Geral/GestaoProdutos/Formularios" as const,
            } as const,
            REGISTRO_VENDA: {
                LISTAGEM: {
                    ID_TELA: 693 as const,
                    DS_PATH: "/Geral/RegistroVenda" as const,
                },
                REGISTRAR: {
                    ID_TELA: 694 as const,
                    DS_PATH: "/Geral/RegistroVenda/Registrar" as const,
                },
                EDITAR: {
                    ID_TELA: 695 as const,
                    DS_PATH: "/Geral/RegistroVenda/EditarVenda/:IdVenda",
                    DS_LINK: (IdVenda: number) =>
                        `/Geral/RegistroVenda/EditarVenda/${IdVenda}` as const,
                } as const,
            } as const,
            DASHBOARD: {
                ID_TELA: 539 as const,
                DS_PATH: "/Geral/Dashboard/" as const,
            } as const,
            CONFIG_EMAIL: {
                ID_TELA: 540 as const,
                DS_PATH: "/Geral/ConfiguracaoEmail/" as const,
            } as const,
            CONFIG_GERAL: {
                ID_TELA: 535 as const,
                DS_PATH: "/Geral/ConfiguracaoGeral" as const,
            } as const,
            TRIAGEM: {
                ID_TELA: 557 as const,
                DS_PATH: "/Geral/Triagem/" as const,
            } as const,
            BLACKLIST: {
                ID_TELA: 557 as const,
                DS_PATH: "/Geral/Blacklist" as const,
            } as const,
            GESTAO_TEMPLATES: {
                ID_TELA: 618 as const,
                DS_PATH: "/Geral/GestaoTemplates/" as const,
            } as const,
            CONFIGURAR_TEMPLATES: {
                ID_TELA: 690 as const,
                DS_PATH:
                    "/Geral/GestaoTemplates/ConfigurarTemplates/:idDocumentoTemplate" as const,
                DS_LINK: (idDocumentoTemplate: number) =>
                    `/Geral/GestaoTemplates/ConfigurarTemplates/${idDocumentoTemplate}` as const,
            } as const,
            ATRIBUTOS_ETAPA: {
                ID_TELA: 672 as const,
                DS_PATH: "/Geral/AtributosEtapa",
            },
            STATUS_ETAPA: {
                ID_TELA: 685 as const,
                DS_PATH: "/Geral/StatusEtapa",
            },
            CATEGORIA_ATENDIMENTO: {
                GESTAO: {
                    ID_TELA: 659 as const,
                    DS_PATH: "/Geral/GestaoCategoriaAtendimento/" as const,
                } as const,
                EDITAR: {
                    ID_TELA: 660 as const,
                    DS_PATH:
                        "/Geral/CategoriaAtendimento/:IdCategoria" as const,
                    DS_LINK: (IdCategoria: number) =>
                        `/Geral/CategoriaAtendimento/${IdCategoria}` as const,
                } as const,
            } as const,
            NOTIFICACOES: {
                DS_PATH: "/Geral/Notificacoes/:tipo" as const,
            } as const,
            CADASTRO_PRODUTO: {
                ID_TELA: 609 as const,
                DS_PATH: "/Geral/GestaoProdutos/CadastrarProduto" as const,
            } as const,
            EDITAR_PRODUTO: {
                ID_TELA: 609 as const,
                DS_PATH:
                    "/Geral/GestaoProdutos/EditarProduto/:idProduto" as const,
                DS_LINK: (idProduto: number) =>
                    `/Geral/GestaoProdutos/EditarProduto/${idProduto}` as const,
            } as const,
            AGENDA: {
                ID_TELA: 609 as const,
                DS_PATH: "/Geral/Agenda" as const,
            } as const,
            BOARD_DEVOPS: {
                ID_TELA: 609 as const,
                DS_PATH: "/Geral/Board" as const,
            } as const,
            BUSCA_DE_CLIENTES_UAU: {
                ID_TELA: 609 as const,
                DS_PATH: "/Geral/BuscaDeCliente" as const,
            } as const,
            EXECUTAR_ETL: {
                ID_TELA: 711 as const,
                DS_PATH: "/Geral/ExecutarETL" as const,
            } as const,
            RESPONDER_FORMULARIO: {
                DS_PATH: "/ResponderFormulario" as const,
                ID_TELA: 609 as const,
            } as const,
            RESPONDER_PEQUISA_SATISFACAO: {
                DS_PATH: "/ResponderPesquisaSatisfacao" as const,
                ID_TELA: 609 as const,
            } as const,
            INFORMACOES_ORGANIZACAO: {
                ID_TELA: 697 as const,
                DS_PATH: "/Geral/InformacoesOrganizacao/" as const,
            } as const,

            GESTAO_TIPO_PARCELAS: {
                ID_TELA: 616 as const,
                DS_PATH: "/Geral/TipoParcelas" as const,
            } as const,
            GESTAO_LOGS_CONTROLE_REPARO: {
                ID_TELA: 731 as const,
                DS_PATH: "/Geral/TrilhaAuditoria" as const,
            } as const,
        },
        MODAIS: {
            TIPO_CANAL_ATENDIMENTO: {
                ID_TELA: 531 as const,
            } as const,
            TIPO_DOCUMENTO_ETAPA: {
                ID_TELA: 664 as const,
            } as const,
            TIPO_RECORRENCIA: {
                ID_TELA: 532 as const,
            } as const,
            TIPO_DOCUMENTO: {
                ID_TELA: 533 as const,
            } as const,
            TIPO_AGENDAMENTO: {
                ID_TELA: 658 as const,
            } as const,
            MOTIVO_CANCELAMENTO: {
                ID_TELA: 534 as const,
            } as const,
            TIPO_RELACAO_CLIENTE: {
                ID_TELA: 558 as const,
            } as const,
            SUBCATEGORIA: {
                ID_TELA: 559 as const,
            } as const,
            TIPO_PESO_ATENDIMENTO: {
                ID_TELA: 662 as const,
            } as const,
            TEMPLATES_MODULO: {
                ID_TELA: 663 as const,
            } as const,
            TIPO_CLIENTE: {
                ID_TELA: 687 as const,
            } as const,
            MOTIVO_PROBLEMA: {
                ID_TELA: 49 as const,
            } as const,
            //CRIAR ID_TELA PARA MOTIVO_NAO_PROCEDENCIA
            MOTIVO_NAO_PROCEDENCIA: {
                ID_TELA: 662 as const,
            } as const,
        },
        DS_BASE_URL: "/Geral",
        NAME: "Geral",
    } as const,

    PORTAL_ADMIN: {
        TELAS: {},
        DS_BASE_URL: "/PortalAdmin",
        NAME: "PortalAdmin",
        ID_MODULO: 7 as const,
    } as const,

    ENTREGA_DE_CHAVES: {
        TELAS: {
            DASHBOARD: {
                ID_TELA: 634 as const,
                DS_PATH: "/EntregaChaves/Dashboard" as const,
            } as const,
            GESTAO_CLIENTES: {
                ID_TELA: 536 as const,
                DS_PATH: "/EntregaChaves/GestaoClientes" as const,
            } as const, //pedir para alterar
            CLIENTE: {
                ID_TELA: 574 as const,
                DS_PATH: "/EntregaChaves/Cliente/:idConta" as const,
                DS_LINK: (IDConta: number) =>
                    `/EntregaChaves/Cliente/${IDConta}` as const,
            } as const,
            CAPYS_BI: {
                ID_TELA: 682 as const,
                DS_PATH: "/EntregaChaves/BIEntregaChaves" as const,
            } as const,
            GESTAO_VISTORIA: {
                ID_TELA: 652 as const,
                DS_PATH: "/EntregaChaves/GestaoVistoria" as const,
            },
            ACOMPANHAMENTOS_VISTORIA: {
                ID_TELA: 665 as const,
                DS_PATH: "/EntregaChaves/AcompanhamentosVistoria",
            },
            ATENDIMENTOS: {
                TODOS: {
                    ID_TELA: 657 as const,
                    DS_PATH: "/EntregaChaves/Atendimentos/Todos" as const,
                },
                GRUPO: {
                    ID_TELA: 644 as const,
                    DS_PATH: "/EntregaChaves/Atendimentos/Grupo" as const,
                },
                MEUS_ATENDIMENTOS: {
                    ACOMPANHAMENTO: {
                        ID_TELA: 643 as const,
                    },
                    USUARIO: {
                        ID_TELA: 643 as const,
                    },
                    DS_PATH: "/EntregaChaves/Atendimentos/Meus" as const,
                } as const,

                ID_TELA: 635 as const,
                DS_PATH: "/EntregaChaves/Atendimentos/" as const,
            } as const,
            GESTAO_CADASTRO: {
                DISPONIBILIDADE_VISTORIA: {
                    ID_TELA: 664,
                    DS_PATH: "/EntregaChaves/DisponibilidadeVistoria",
                },
                HORARIOS_DISPONIVEIS: {
                    ID_TELA: 698,
                    DS_PATH: "/EntregaChaves/DisponibilidadeVistoriaHorarios",
                },
            },

            ATENDIMENTO: {
                ID_TELA: 638 as const,
                DS_PATH: "/EntregaChaves/Atendimento/:IDCaso" as const,
                DS_LINK: (IDCaso: number) =>
                    `/EntregaChaves/Atendimento/${IDCaso}` as const,
            } as const,

            GESTAO_ATIVIDADES: {
                ID_TELA: 726 as const,
                DS_PATH: "/EntregaChaves/GestaoAtividades" as const,
            } as const,

            PESQUISA_SATISFACAO: {
                ID_TELA: 707 as const,
                DS_PATH: "/EntregaChaves/PesquisaSatisfacao" as const,
            } as const,
        },
        DS_BASE_URL: "/EntregaChaves",
        NAME: "EntregaChaves",
        ID_MODULO: 10 as const,
    },

    ASSISTENCIA: {
        TELAS: {
            DASHBOARD: {
                ID_TELA: 0 as const,
                DS_PATH: "/AssistenciaTecnica/Dashboard" as const,
            } as const,
            GESTAO_CLIENTES: {
                ID_TELA: 536 as const,
                DS_PATH: "/AssistenciaTecnica/GestaoClientes/" as const,
            } as const,
            TRIAGEM: {
                ID_TELA: 536 as const,
                DS_PATH: "/AssistenciaTecnica/Triagem/" as const,
            } as const,
            CLIENTE: {
                ID_TELA: 574 as const,
                DS_PATH: "/AssistenciaTecnica/Cliente/:idConta" as const,
                DS_LINK: (IDConta: number) =>
                    `/AssistenciaTecnica/Cliente/${IDConta}` as const,
            } as const,
            ATENDIMENTO: {
                ID_TELA: 645 as const,
                DS_PATH: "/AssistenciaTecnica/Atendimento/:IDCaso" as const,
                DS_LINK: (IDCaso: number) =>
                    `/AssistenciaTecnica/Atendimento/${IDCaso}` as const,
            } as const,
            GESTAO_ATENDIMENTOS: {
                TODOS: {
                    ID_TELA: 666 as const,
                    DS_PATH: "/AssistenciaTecnica/Todos" as const,
                    DS_LINK: (IDConta: number) =>
                        `/Geral/Cliente/${IDConta}` as const,
                } as const,
                GRUPO: {
                    ID_TELA: 668 as const,
                    DS_PATH: "/AssistenciaTecnica/Grupo" as const,
                } as const,
                MEUS_ATENDIMENTOS: {
                    ACOMPANHAMENTO: {
                        ID_TELA: 667 as const,
                    },
                    USUARIO: {
                        ID_TELA: 667 as const,
                    },
                    DS_PATH: "/AssistenciaTecnica/Meus" as const,
                } as const,
                CAPYS_BI: {
                    ID_TELA: 605 as const,
                    DS_PATH: "/AssistenciaTecnica/CapysBI" as const,
                } as const,
                CAPYS_BI_GERENCIAL: {
                    ID_TELA: 716 as const,
                    DS_PATH: "/AssistenciaTecnica/CapysBIGerencial" as const,
                } as const,
                CAPYS_BI_CUSTO_OFICIAL: {
                    ID_TELA: 712 as const,
                    DS_PATH: "/AssistenciaTecnica/CustoOficial" as const,
                } as const,
                CAPYS_BI_CUSTO_PREVISTO_VGV: {
                    ID_TELA: 712 as const,
                    DS_PATH: "/AssistenciaTecnica/CustoPrevistoVGV" as const,
                } as const,
                CAPYS_BI_CUSTO_ENCARREGADO: {
                    ID_TELA: 712 as const,
                    DS_PATH: "/AssistenciaTecnica/CustoEncarregado" as const,
                } as const,
                CAPYS_BI_CUSTO_PREVISTO_VGV_MENSAL: {
                    ID_TELA: 712 as const,
                    DS_PATH:
                        "/AssistenciaTecnica/CustoPrevistoVGVMensal" as const,
                } as const,
                CAPYS_BI_CADASTRO_DIRECIONAMENTO: {
                    ID_TELA: 712 as const,
                    DS_PATH: "/AssistenciaTecnica/Direcionamento" as const,
                } as const,
            },
            CAPYS_BI_NPS: {
                ID_TELA: 722 as const,
                DS_PATH: "/AssistenciaTecnica/BINps" as const,
            } as const,
            CAPYS_BI_CSAT: {
                ID_TELA: 723 as const,
                DS_PATH: "/AssistenciaTecnica/BICsat" as const,
            } as const,

            GESTAO_ATIVIDADES: {
                ID_TELA: 726 as const,
                DS_PATH: "/AssistenciaTecnica/GestaoAtividades" as const,
            } as const,

            PESQUISA_SATISFACAO: {
                ID_TELA: 707 as const,
                DS_PATH: "/AssistenciaTecnica/PesquisaSatisfacao" as const,
            } as const,
        },
        MODAIS: {
            DISPONIBILIDADE_AGENDAMENTO: {
                ID_TELA: 689 as const,
            } as const,
        },
        DS_BASE_URL: "/AssistenciaTecnica",
        NAME: "AssistenciaTecnica",
        ID_MODULO: 1 as const,
    } as const,
    REPASSE: {
        TELAS: {
            DASHBOARD: {
                ID_TELA: 653 as const,
                DS_PATH: "/Repasse/Dashboard" as const,
            } as const,
            GESTAO_CLIENTES: {
                ID_TELA: 536 as const,
                DS_PATH: "/Repasse/GestaoClientes/" as const,
            } as const,
            GESTAO_REPASSE: {
                ID_TELA: 654 as const,
                DS_PATH: "/Repasse/GestaoRepasse/" as const,
            } as const,
            CAPYS_BI: {
                ID_TELA: 655 as const,
                DS_PATH: "/Repasse/CapysBI" as const,
            } as const,
            GESTAO_ATENDIMENTOS: {
                TODOS: {
                    ID_TELA: 600 as const,
                    DS_PATH: "/Repasse/Gestao/Todos" as const,
                },
                GRUPO: {
                    ID_TELA: 603 as const,
                    DS_PATH: "/Repasse/Gestao/Grupo" as const,
                },
                MEUS_ATENDIMENTOS: {
                    ACOMPANHAMENTO: {
                        ID_TELA: 602 as const,
                    },
                    USUARIO: {
                        ID_TELA: 601 as const,
                    },
                    DS_PATH: "/Repasse/Gestao/Meus" as const,
                } as const,
            },
            CLIENTE: {
                ID_TELA: 574 as const,
                DS_PATH: "/Repasse/Cliente/:idConta" as const,
                DS_LINK: (IDConta: number) =>
                    `/Repasse/Cliente/${IDConta}` as const,
            } as const,
            ATENDIMENTO: {
                ID_TELA: 637 as const,
                DS_PATH: "/Repasse/Atendimento/:IDCaso" as const,
                DS_LINK: (IDCaso: number) =>
                    `/Repasse/Atendimento/${IDCaso}` as const,
            } as const,
            ETAPAS_GRUPO: {
                ID_TELA: 646 as const,
                DS_PATH: "/Repasse/EtapasGrupo" as const,
            } as const,
            REPASSE_BI: {
                ID_TELA: 692 as const,
                DS_PATH: "/repasse/dadosbi" as const,
            } as const,

            PESQUISA_SATISFACAO: {
                ID_TELA: 707 as const,
                DS_PATH: "/Repasse/PesquisaSatisfacao" as const,
            } as const,
        },
        DS_BASE_URL: "/Repasse",
        NAME: "Repasse",
        ID_MODULO: 5 as const,
    } as const,
    VENDAS: {
        PRODUTOS: {
            TELAS: {
                PAINEL_IMPLANTACAO: {
                    ID_TELA: 656 as const,
                    DS_PATH: "/Vendas/PainelImplantacao" as const,
                },
            },
        },
        TELAS: {
            DASHBOARD: {
                ID_TELA: 0 as const,
                DS_PATH: "/Vendas/Dashboard" as const,
            } as const,
            GESTAO_VISITAS: {
                ID_TELA: 620 as const,
                DS_PATH: "/Vendas/GestaoDeVisitas/" as const,
            },
            GESTAO_CLIENTES: {
                ID_TELA: 536 as const,
                DS_PATH: "/Vendas/GestaoClientes/" as const,
            } as const,
            GESTAO_OPORTUNIDADES: {
                ID_TELA: 724 as const,
                DS_PATH: "/Vendas/GestaoOportunidades/" as const,
            } as const,
            GESTAO_ATENDIMENTOS: {
                TODOS: {
                    ID_TELA: 604 as const,
                    DS_PATH: "/Vendas/Gestao/Todos" as const,
                },
                GRUPO: {
                    ID_TELA: 603 as const,
                    DS_PATH: "/Vendas/Gestao/Grupo" as const,
                },
                MEUS_ATENDIMENTOS: {
                    ACOMPANHAMENTO: {
                        ID_TELA: 602 as const,
                    },
                    USUARIO: {
                        ID_TELA: 601 as const,
                    },
                    DS_PATH: "/Vendas/Gestao/Meus" as const,
                } as const,
            },
            ANALISE_CREDITO: {
                ID_TELA: 619 as const,
                DS_PATH: "/Vendas/AnaliseDeCredito" as const,
            },
            GESTAO_PRODUTOS: {
                ID_TELA: 729 as const,
                DS_PATH: "/Vendas/ConsultarProdutos" as const,
            },

            GESTAO_PRODUTOS_VENDAS: {
                ID_TELA: 537 as const,
                DS_PATH: "/Vendas/GestaoProdutos" as const,
            },
            MAPA_IMPLANTACAO: {
                ID_TELA: 656 as const,
                DS_PATH: "/Vendas/MapaImplantacao/:productObject" as const,
                DS_LINK: <T>(productObject: T) =>
                    `/Vendas/MapaImplantacao/${productObject}` as const,
            },

            CADASTRO_PRODUTO: {
                ID_TELA: 609 as const,
                DS_PATH: "/Vendas/GestaoProdutos/CadastrarProduto" as const,
            } as const,
            EDITAR_PRODUTO: {
                ID_TELA: 609 as const,
                DS_PATH:
                    "/Vendas/GestaoProdutos/EditarProduto/:idProduto" as const,
                DS_LINK: (idProduto: number) =>
                    `/Vendas/GestaoProdutos/EditarProduto/${idProduto}` as const,
            } as const,
            CLIENTE: {
                ID_TELA: 574 as const,
                DS_PATH: "/Vendas/Cliente/:idConta" as const,
                DS_LINK: (IDConta: number) =>
                    `/Vendas/Cliente/${IDConta}` as const,
            } as const,
            GESTAO_RESERVAS: {
                ID_TELA: 614 as const,
                DS_PATH: "/Vendas/Reservas" as const,
            } as const,
            GESTAO_CADASTRO: {
                CRIAR_EQUIPE_VENDA: {
                    ID_TELA: 683 as const,
                    DS_PATH: "/Vendas/Cadastro" as const,
                } as const,
                VINCULAR_PRODUTO_VENDA: {
                    ID_TELA: 684 as const,
                    DS_PATH: "/Vendas/Vincular" as const,
                } as const,
                USUARIOS_EQUIPE_VENDAS: {
                    ID_TELA: 686 as const,
                    DS_PATH: "/Vendas/UsuariosEquipeVenda" as const,
                },
                ETAPAS_GRUPO: {
                    ID_TELA: 725 as const,
                    DS_PATH: "/Vendas/EtapasGrupo" as const,
                },
            } as const,
            ESPELHO_VENDAS: {
                ID_TELA: 639 as const,
                DS_PATH: "/Vendas/EspelhoVendas/" as const,
            } as const,
            ATENDIMENTO: {
                ID_TELA: 636 as const,
                DS_PATH: "/Vendas/Atendimento/:IDCaso" as const,
                DS_LINK: (IDCaso: number) =>
                    `/Vendas/Atendimento/${IDCaso}` as const,
            } as const,
            ENVELOPES: {
                ID_TELA: 647 as const,
                DS_PATH: "/Vendas/Envelopes/" as const,
            } as const,
            GESTAO_CONFIG_ENVELOPES: {
                ID_TELA: 640 as const,
                DS_PATH: "/Vendas/:idProduto/ConfigEnvelope" as const,
                DS_LINK: (idProduto: number) =>
                    `/Vendas/${idProduto}/ConfigEnvelope` as const,
            } as const,
            GESTAO_LEADS: {
                CADASTRO_LEAD: {
                    ID_TELA: 683 as const,
                    DS_PATH: "/Vendas/CadastroLead" as const,
                } as const,
            } as const,

            RELATORIOS_BI_LEADS: {
                ID_TELA: 684 as const,
                DS_PATH: "/Vendas/RelatoriosBI/Leads" as const,
            },
            RELATORIOS_BI_VISITA: {
                ID_TELA: 684 as const,
                DS_PATH: "/Vendas/RelatoriosBI/Visita" as const,
            },
            RELATORIOS_BI_ANALISE_CREDITO: {
                ID_TELA: 684 as const,
                DS_PATH: "/Vendas/RelatoriosBI/AnaliseCredito" as const,
            },
            RELATORIOS_BI_VENDAS: {
                ID_TELA: 684 as const,
                DS_PATH: "/Vendas/RelatoriosBI/Vendas" as const,
            },
            RELATORIOS_BI_ESTOQUE: {
                ID_TELA: 684 as const,
                DS_PATH: "/Vendas/RelatoriosBI/Estoque" as const,
            },
            RELATORIOS_BI_PERDAS: {
                ID_TELA: 684 as const,
                DS_PATH: "/Vendas/RelatoriosBI/Perdas" as const,
            },
            RELATORIOS_BI_MARKETING: {
                ID_TELA: 684 as const,
                DS_PATH: "/Vendas/RelatoriosBI/Marketing" as const,
            },
            RELATORIOS_BI_GESTAO_ATENDIMENTO: {
                ID_TELA: 684 as const,
                DS_PATH: "/Vendas/RelatoriosBI/GestaoAtendimento" as const,
            },

            GESTAO_ATIVIDADES: {
                ID_TELA: 726 as const,
                DS_PATH: "/Vendas/GestaoAtividades" as const,
            } as const,

            PAINEL_RESUMO: {
                ID_TELA: 728 as const,
                DS_PATH: "/Vendas/DashboardCorretor" as const,
            } as const,

            PESQUISA_SATISFACAO: {
                ID_TELA: 707 as const,
                DS_PATH: "/Vendas/PesquisaSatisfacao" as const,
            } as const,
        },
        DS_BASE_URL: "/Vendas",
        NAME: "Vendas",
        ID_MODULO: 4 as const,
    } as const,
    AUTOMACAO: {
        TELAS: {
            AUDIENCIA: {
                ID_TELA: 703 as const,
                DS_PATH: "/Automacao/Audiencia" as const,
            } as const,
            AUDIENCIA_CONTATO: {
                ID_TELA: 704 as const,
                DS_PATH: "/Automacao/:idAudiencia/Contatos" as const,
                DS_LINK: (idAudiencia: number) =>
                    `/Automacao/${idAudiencia}/Contatos` as const,
            } as const,
            VINCULAR_CONTATOS: {
                ID_TELA: 705 as const,
                DS_PATH: "/Automacao/VincularContatos/:idAudiencia" as const,
                DS_LINK: (idAudiencia: number) =>
                    `/Automacao/VincularContatos/${idAudiencia}` as const,
            } as const,
            DESVINCULAR_CONTATOS: {
                ID_TELA: 706 as const,
                DS_PATH: "/Automacao/DesvincularContatos/:idAudiencia" as const,
                DS_LINK: (idAudiencia: number) =>
                    `/Automacao/DesvincularContatos/${idAudiencia}` as const,
            } as const,
            REGUA: {
                CONFIG: {
                    ID_TELA: 560 as const,
                    DS_PATH: "/Automacao/Regua/Configuracao",
                } as const,
                GESTAO: {
                    ID_TELA: 560 as const,
                    DS_PATH: "/Automacao/Regua/Gestao",
                } as const,
                RELATORIOS: {
                    ID_TELA: 560 as const,
                    DS_PATH: "/Automacao/Regua/Relatorios",
                } as const,
                RELATORIOS_BI: {
                    ID_TELA: 709 as const,
                    DS_PATH: "/Automacao/Regua/RelatoriosBI",
                } as const,
                EDITAR: {
                    ID_TELA: 560 as const,
                    DS_PATH: "/Automacao/Regua/EditarRegua/:IdRegua",
                    DS_LINK: (IdRegua: number) =>
                        `/Automacao/Regua/EditarRegua/${IdRegua}` as const,
                } as const,
            } as const,
            FORMULARIOS: {
                ID_TELA: 610 as const,
                DS_PATH: "/Automacao/Formularios/" as const,
            } as const,
        },
        DS_BASE_URL: "/Automacao",
        NAME: "Automacao",
        ID_MODULO: 11 as const,
    } as const,

    OUTROS: {
        TELAS: {
            AGENDA: {
                DS_PATH: "/Agenda" as const,
                ID_TELA: 609 as const,
            } as const,
        } as const,
    } as const,
};
